import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const CategoryNav: React.FC = () => {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            福利分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            按类别精准查找，快速发现您需要的福利优惠
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 bg-white rounded-xl border border-background-200 hover:border-primary-300 hover:shadow-md transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl mb-3 md:mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryNav;